import {Subject,  Observable, of as observableOf } from 'rxjs';
import { switchMap, debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Employee } from './../../models/identity/employee.model';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { HttpParams } from '@angular/common/http';
import { EmployeeApprovalSearchRequest, BusinessUnit } from '../../models/identity';
import { ProcessParticipation, KnownProcessType } from '../../models/process-models';
import { Respondent } from '../../models/respondent.model';
import { ProcessParticipationService } from '../../services/process.participation.service';
import { Location } from '@angular/common';
import { ConfirmationRespondentService } from '../../services/confirmation-respondent.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-respondents-approval-search-page',
  templateUrl: './respondents-approval-search-page.component.html',
  styleUrls: ['./respondents-approval-search-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RespondentsApprovalSearchPageComponent implements OnInit {

  searchPattern$ = new Subject<string>();
  selectionType: number;
  processAppraiseeDurationId: number;
  employeeApprovalSearchRequest: EmployeeApprovalSearchRequest = {};
  employees: Array<Employee> = [];
  businessUnits: Array<BusinessUnit>;
  term: any;
  
  constructor(private readonly configService: ConfigService, private readonly userService: UserService,
  private readonly route: ActivatedRoute, private readonly processParticipationService: ProcessParticipationService,
  private readonly ref: ChangeDetectorRef, private location: Location, 
  private readonly confirmationService: ConfirmationRespondentService, private readonly toastr: ToastrService,
  private translate: TranslateService) { }

  ngOnInit() {
    this.searchRespondents();
  }

  emitSearchPattern(searchPattern: any) {
    this.searchPattern$.next(searchPattern);
  }

  setSearchRequest(searchRequest: EmployeeApprovalSearchRequest) {
    this.selectionType = +this.route.snapshot.paramMap.get('selectionType');
    this.processAppraiseeDurationId = +this.route.snapshot.paramMap.get('id');
    searchRequest.selectionCriterionType = this.selectionType;
    this.employeeApprovalSearchRequest = searchRequest;  
    this.ref.detectChanges();  
  }

  getSelectionColumnName(): Observable<any> {
    return (this.selectionType) ? 
    this.confirmationService.getSelectionColumnTranslation(this.selectionType) : observableOf('');
  }

  addRespondent(employee: Employee) {
    const respondent: Respondent = {
      id: employee.id,
      knownProcessTypes: [KnownProcessType._360],
      selectedProcessParticipationSelectionCriterionType: this.employeeApprovalSearchRequest.selectionCriterionType
    };
    const processParticipation: ProcessParticipation = {
      respondents: [respondent],
      processDurationAppraiseeId: this.processAppraiseeDurationId,
    };
    this.processParticipationService.addRespondentsToApprove(processParticipation)
        .subscribe(result => {
        this.employees = this.updateRespondents(employee.id);
        this.getSuccessToaster();
        this.ref.detectChanges();
        }, error => {
            let header = '';
            let body = '';
            const errorPath = 'error.assignRespondents.dublicationRespondent';
            this.translate
                .get(errorPath + '.head')
                .subscribe(x => {
                    header = x;
                });
            this.translate
                .get(errorPath + '.body')
                .subscribe(x => {
                    body = x;
                });
            this.toastr.error(body, header);
        });
        this.term = "";
        this.emitSearchPattern(this.term);
  }

  return() {
    this.location.back();
  }

  private searchRespondents() {
    this.searchPattern$.pipe(
      debounceTime(this.configService.configData.searchPersonDebounceTime),
      switchMap(term => {
        if (term.length < this.configService.configData.minimumSearchStringLength) {
          return observableOf();
        }
        return this.userService.getApprovalEmployees(term, this.setHttpParams());
      }))
      .subscribe(x => {
        this.employees = x as Array<Employee>;
        this.ref.detectChanges();
      });
  }

  private getSuccessToaster() {
    const translateToasterHeadKey = 'success.assignRespondents.head';
    const translateToasterBodyKey = 'success.assignRespondents.body';
    const toasterTranslation = this.translate.get([translateToasterHeadKey, translateToasterBodyKey]);
    let head = ''; let body = '';
    toasterTranslation.subscribe(x => {
      body = x[translateToasterBodyKey];
      head =  x[translateToasterHeadKey];
      this.toastr.success(body, head);
      });
      
  }

  private setHttpParams(): HttpParams {
    let params = new HttpParams();
    params = params.append('selectionCriterionType', this.employeeApprovalSearchRequest.selectionCriterionType.toString());
    params = params.append('appraiseeGradeLevel', this.employeeApprovalSearchRequest.appraiseeGradeLevel.toString());
    params = params.append('appraiseePersonId', this.employeeApprovalSearchRequest.appraiseePersonId.toString());
     return params;
  }

  private updateRespondents(respondentId: number): Array<Employee> {
    return this.employees.filter(x => x.id !== respondentId);
  }
}
